/*
 * @ Author: wangjiyu
 * @Date: 2019-12-19 09:52:52
 * @LastEditTime : 2021-08-19 16:00:44
 * @LastEditors  : 蔡传明
 * @Description: file content
 */
import HttpClient from '@chehejia/club-lib/lib/httpUtils/HttpClient';
import Constants from '../../enum/Constants';

export default class PostsService {
    // 获取我的视频列表
    public static videoPosts(param) {
        const config: any = {};
        const defaultParam: any = {
            pageNo: 1,
            pageSize: 10,
        };
        config.params = Object.assign(defaultParam, param);
        return HttpClient.get(Constants.getQuestion(), '/product/pa/videos', config).then((data) => {
            return data;
        });
    }
    // 删除帖子
    public static delPosts(id, config?) {
        return HttpClient.delete(Constants.getQuestion(), `/product/pa/del/${id}`, config).then((data) => {
            return data;
        });
    }
    // 获取我的动态列表
    public static picsPosts(param) {
        const config: any = {};
        const defaultParam: any = {
            pageNo: 1,
            pageSize: 10,
        };
        config.params = Object.assign(defaultParam, param);
        return HttpClient.get(Constants.getQuestion(), '/product/pa/pics', config).then((data) => {
            return data;
        });
    }
    // 获取我的图文混排列表
    public static editPicsList(param) {
        const config: any = {};
        const defaultParam: any = {
            pageNo: 1,
            pageSize: 10,
        };
        config.params = Object.assign(defaultParam, param);
        return HttpClient.get(
            Constants.getQuestion(),
            '/product/pa/graphics',
            config
        ).then((data) => {
            return data;
        });
    }
}
